/**
 * Ce fichier permets d'afficher la positions en temps réel
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/
import React from 'react';
import { useSelector } from 'react-redux';

import PositionsMapLive from './PositionsMapLive';
import { selectPositionsArray } from '../createSelectorUtils';

/*-------------------------------------------------------------------------------------------*/

function CurrentPositionsMap() {
  const positions = useSelector(selectPositionsArray);
  return <PositionsMapLive positions={positions} />;
}

export default CurrentPositionsMap;
